import React, { useCallback } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import useIdleLogout from './utils/useIdleLogout';
import Login from './pages/Login';
import Projects from './pages/Projects';
import Buildings from './pages/Buildings';
import Apartments from './pages/Apartments';
import ApartmentDetail from './pages/ApartmentDetail';
import Reports from './pages/Reports';
import Dashboard from './pages/Dashboard';
import Portal from './pages/Portal';
import ProjectHub from './pages/ProjectHub';
import About from './pages/About';
import Files from './pages/Files';
import TenantLogin from './pages/TenantLogin';
import TenantProjects from './pages/TenantProjects';
import TenantPortal from './pages/TenantPortal';
import AdminViewAs from './pages/AdminViewAs';
import WorkerCard from './pages/WorkerCard';
import CompanyCard from './pages/CompanyCard';
import PersonCard from './pages/PersonCard';
import DigitalCardEditor from './pages/DigitalCardEditor';
import InstallApp, { InstallAppTenant } from './pages/InstallApp';
import EventRSVP from './pages/EventRSVP';
import Events from './pages/Events';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Placements from './pages/Placements';
import TenantReplies from './pages/TenantReplies';

function PrivateRoute({ children }) {
  const handleIdleLogout = useCallback(() => {
    localStorage.removeItem('token');
    window.location.href = '/admin';
  }, []);
  useIdleLogout(12 * 60 * 60 * 1000, handleIdleLogout); // ניתוק אוטומטי אחרי 12 שעות חוסר פעילות

  if (localStorage.getItem('token')) return children;
  localStorage.setItem('redirectAfterLogin', window.location.pathname + window.location.search);
  return <Navigate to="/admin" />;
}

function TenantRoute({ children }) {
  return localStorage.getItem('tenantProject') ? children : <Navigate to="/portal" />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Admin routes */}
        <Route path="/login" element={<Navigate to="/admin" />} />
        <Route path="/admin" element={<Login />} />
        <Route path="/admin" element={<PrivateRoute><Projects /></PrivateRoute>} />
        <Route path="/projects" element={<PrivateRoute><Projects /></PrivateRoute>} />
        <Route path="/buildings/:projectName" element={<PrivateRoute><Buildings /></PrivateRoute>} />
        <Route path="/apartments/:addr/:num" element={<PrivateRoute><Apartments /></PrivateRoute>} />
        <Route path="/apartment/:addr/:num/:aptNum" element={<PrivateRoute><ApartmentDetail /></PrivateRoute>} />
        <Route path="/reports/:projectName" element={<PrivateRoute><Reports /></PrivateRoute>} />
        <Route path="/dashboard/:projectName" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
        <Route path="/admin/:projectName" element={<PrivateRoute><Portal /></PrivateRoute>} />
        <Route path="/card-editor/:projectName" element={<PrivateRoute><DigitalCardEditor /></PrivateRoute>} />
        <Route path="/install-app" element={<InstallApp />} />
        <Route path="/install-app-tenant" element={<InstallAppTenant />} />
        <Route path="/project-hub/:projectName" element={<PrivateRoute><ProjectHub /></PrivateRoute>} />
        <Route path="/about/:projectName" element={<PrivateRoute><About /></PrivateRoute>} />
        <Route path="/files/:projectName" element={<PrivateRoute><Files /></PrivateRoute>} />
        <Route path="/events/:projectName" element={<PrivateRoute><Events /></PrivateRoute>} />
        <Route path="/placements/:projectName" element={<PrivateRoute><Placements /></PrivateRoute>} />

        {/* Public digital business cards — no login required, like /portal below */}
        <Route path="/card/worker/:slug" element={<WorkerCard />} />
        <Route path="/card/company/:slug" element={<CompanyCard />} />
        <Route path="/card/person/:slug" element={<PersonCard />} />
        <Route path="/event/:token" element={<EventRSVP />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />

        {/* Tenant routes */}
        <Route path="/portal" element={<TenantLogin />} />
        <Route path="/tenant-projects" element={<TenantProjects />} />
        <Route path="/portal-replies" element={<TenantReplies />} />
        <Route path="/portal/:projectName" element={<TenantRoute><TenantPortal /></TenantRoute>} />
        <Route path="/admin-view-as" element={<PrivateRoute><AdminViewAs /></PrivateRoute>} />

        <Route path="/" element={<Navigate to="/portal" />} />
        <Route path="*" element={<Navigate to="/portal" />} />
      </Routes>
    </BrowserRouter>
  );
}
